class ContractorApiService {
  constructor() {
    // Use environment variable or detect local development
    if (process.env.NODE_ENV === 'development' && window.location.hostname === 'localhost') {
      this.baseUrl = 'https://localhost:7080/api'; // Local .NET API
    } else {
      this.baseUrl = process.env.REACT_APP_API_URL || 'https://xero-payment-api-cmb-c0epbxffhccgdsbs.canadacentral-01.azurewebsites.net/api';
    }
    console.log('🔗 Contractor API Base URL:', this.baseUrl);
    console.log('🌍 Contractor Environment:', process.env.NODE_ENV);
    console.log('🏠 Contractor Hostname:', window.location.hostname);
  }

  async apiCall(endpoint, options = {}) {
    const url = `${this.baseUrl}${endpoint}`;
    const token = this.getToken();
    
    const config = {
      headers: {
        'Content-Type': 'application/json',
        ...(token && { 'Authorization': `Bearer ${token}` }),
        ...options.headers
      },
      ...options
    };

    try {
      console.log('🔐 Contractor Data API Call:', options.method || 'GET', endpoint);
      console.log('🔗 Full URL:', url);
      console.log('🎫 Token present:', !!token);
      if (token) {
        console.log('🎫 Token preview:', token.substring(0, 20) + '...');
      }
      
      const response = await fetch(url, config);
      
      console.log('📡 Response status:', response.status, response.statusText);
      
      if (!response.ok) {
        const errorData = await response.json().catch(() => ({ error: 'Unknown error' }));
        console.error('❌ API Error Response:', errorData);
        throw new Error(errorData.error || `HTTP ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      console.log('✅ API Success Response:', data);
      return data;
    } catch (error) {
      console.error('❌ Contractor Data API Error:', error);
      throw error;
    }
  }

  async getDashboard() {
    return await this.apiCall('/contractor/dashboard');
  }

  async getPaymentHistory() {
    return await this.apiCall('/contractor/payment-history');
  }

  async getBatchPaymentHistory() {
    return await this.apiCall('/contractor/batch-payment-history');
  }

  async getXeroChecks() {
    return await this.apiCall('/contractor/xero-checks');
  }

  getToken() {
    return localStorage.getItem('contractorToken');
  }
}

export default new ContractorApiService();

